import React from 'react'

export const Section = ({ background, children }) => (
  <div css={{ padding: '120px 15px', background }}>{children}</div>
)
